export const isFunction = value => {
  return value && typeof value === 'function';
};

export const isPromise = promise => promise instanceof Promise;
